import { render, staticRenderFns } from "./ModalAlterarClassificacao.vue?vue&type=template&id=e4276c96&scoped=true"
import script from "./ModalAlterarClassificacao.vue?vue&type=script&lang=js"
export * from "./ModalAlterarClassificacao.vue?vue&type=script&lang=js"
import style0 from "./ModalAlterarClassificacao.vue?vue&type=style&index=0&id=e4276c96&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4276c96",
  null
  
)

export default component.exports